// Simple module to hold the auth token, avoiding circular dependencies
// between api.ts and authStore.ts

let currentToken: string | null = null

export function setToken(token: string | null) {
  currentToken = token
}

export function getToken(): string | null {
  return currentToken
}
